import BvInline from 'volta/components/bv-inline';
import BvIcon from 'volta/components/bv-icon';
import CodeDesc from 'volta/components/code-desc';

import type { TOC } from '@ember/component/template-only';
import type Workshop from 'volta/models/workshop';

interface Signature {
  Args: {
    workshop: Workshop;
  };
  Element: HTMLDivElement;
}

const Item: TOC<Signature> = <template>
  <BvInline
    @blockAlign='center'
    @gap='2'
    @align='space-between'
    @wrap={{true}}
    class='u-full-width'
    ...attributes
  >
    <CodeDesc @code={{@workshop.code}} @desc={{@workshop.description}} />
    {{#if @workshop.workshopTypeOptions.length}}
      <BvInline @blockAlign='center' @gap='1'>
        {{#each @workshop.workshopTypeOptions as |workshopTypeOption|}}
          <BvIcon @glyph={{workshopTypeOption.icon}} @size='sm' />
        {{/each}}
      </BvInline>
    {{/if}}
  </BvInline>
</template>;

export default Item;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workshops::WorkshopSelectItem': typeof Item;
    'workshops/workshop-select-item': typeof Item;
  }
}
